import { createReducer } from '@reduxjs/toolkit'
import * as actions from './actions'

export interface GlobalState {
  filterBlur: any
  isModalOpenModalConfirm: {
    toggle: boolean
    type: string
    viewModalDefault: number
    data: any
  }
}

const initialState: GlobalState = {
  filterBlur: false,
  isModalOpenModalConfirm: {
    toggle: false,
    type: '',
    viewModalDefault: 0,
    data: {},
  },
}

export default createReducer(initialState, (builder) =>
  builder
    .addCase(actions.setFilterBlur, (state, { payload }) => {
      state.filterBlur = payload
    })
    .addCase(actions.setIsModalOpenModalConfirm, (state, { payload }) => {
      state.isModalOpenModalConfirm = payload
    }),
)
